import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
    profile: any;


  constructor(
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
  ) {}


    ngOnInit(): void {


    this.commonService.profile$.subscribe((data) => {
    this.profile = data;
  });
  }
}
